import { AJOObject, AJOUpdater } from 'mp-js-react-auto-json-object';
import { useEffect, useState } from 'react';
import AppManager from '../../commun/AppManager';
import { ComplexInput } from '../../commun/component/ComplexInput';
import Table from '../../commun/table/Table';
import Budget from '../../object/Budget';
import { Paper } from '../../object/Paper';
import { ListComplexSelect } from '../ListComplexSelect';
import { BudgetFieldView } from './BudgetFieldView';
import { RightClickBudget } from './RightClickBudget';
import ReactStars from 'react-stars';
import { post } from '../../commun/HTTP';
import Result from '../../commun/Result';
import BasePrice from 'src/object/BasePrice';

export interface IBudgetNoteViewProps {
    budget: Budget;
    basePrice: BasePrice;
}
export const BudgetNoteView: React.FC<IBudgetNoteViewProps> = (props) => {
    const { budget, basePrice } = props;

    const [value, setValue] = useState(budget.getMyNote()?.rate.get() ?? undefined);

    const ratingChanged = (value: number) => {
        if (budget.getMyNote() == null) {
            post('/note/update', {
                rate: value,
                budget: {
                    id: budget.getAjoIdentifier(),
                },
            }).then((res: any) => {
                if (Result.isSuccess(res)) {
                    Result.applyResult(res, AppManager.updater(), true, true);
                }
            });
        } else {
            post('/note/update', {
                id: budget.getMyNote()?.getAjoIdentifier(),
                rate: value,
            }).then((res: any) => {
                if (Result.isSuccess(res)) {
                    Result.applyResult(res, AppManager.updater(), true, true);
                }
            });
        }
        setValue(value);
    };

    if (budget instanceof Budget) {
        return <ReactStars count={5} value={value} half={true} color1={'#B1B6C0'} onChange={ratingChanged} size={30} />;
    } else {
        return null;
    }
};
